import { IMailingList } from './mailing-list.interface';

export class MailingListModel implements IMailingList {
  public mls_key: string = undefined;
  public mls_name: string = undefined;
  public mls_type_code: string = undefined;

  constructor(source?: any) {
    if (source) {
      for (const key in this) {
        if (key in source) {
          this[key] = source[key];
        }
      }
    }
  }
}
